import { writable } from "svelte/store"

/**
 * @typedef {Object} defaultFonts - it contains the font family,addcustomFonts and newfontlistModals
 * @type {Object}
 *  it contains the font family,addcustomFonts and newfontlistModals
 *
 * @property {Array<String>} selectedFonts - Default browser fonts displayed in dropdowns
 * @property {boolean} addCustomFont - to Display the customFont modal
 * @property {boolean} newFontListModal - to Display Font lists.
 * @property {boolean} fontList - to diplay all fonts in add font to list.
 */

/**
 * @type {import("svelte/store").Writable<defaultFonts>}
 */
const defaultFonts = writable({
  //default browser fonts
  selectedFonts: ["Arial", "Arial Black", "Algerian", "Courier New", "Comic Sans MS", "Impact", "Times New Roman", "Tahoma", "Verdana"],
  //choose new font added in api fonts
  fontList: [],
  addCustomFont: false,
  newFontListModal: false,
})
export default defaultFonts
